import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_CUSTOMER_COUNT = "getCustomerCount";


// mutation types
export const SET_CUSTOMER_COUNT = "setCustomerCount";
export const SET_GATEWAY_COUNT = "setGatewayCount";
export const SET_SATTLING_BALANCE = "setSattlingBalance";
export const SET_MONTH_TRANSACTION_COUNT = "setMonthTransactionCount";
export const SET_MONTH_DOLLER_TRANSACTION_COUNT = "setMonthDollerTransactionCount";
export const SET_ACTIVE_DOLLER_GATEWAY_COUNT = "setActiveDollarGatewayCount";
export const SET_MONTH_Us_INCOME = "setMonthDollerIncome";
export const SET_MONTH_INCOME = "setMonthIncome";


export default {
    state: {

        customerCount: null,
        gatewayCount: null,
        sattlingBalance: null,
        monthTransactionCount: null,
        monthDollerTransactionCount: null,
        activeDollarGatewayCount: null,
        monthIncome: null,
        usMonthIncome: null

    },
    getters: {

        loadedCustomerCount(state) {
            return state.customerCount;
        },
        loadedGatewayCount(state) {
            return state.gatewayCount;
        },
        loadedSattlingBalance(state) {
            return state.sattlingBalance;
        },
        loadedMonthTransactionCount(state) {
            return state.monthTransactionCount;
        },
        loadedMonthDollerTransactionCount(state) {
            return state.monthDollerTransactionCount;
        },
        loadedActiveDollarGatewayCount(state) {
            return state.activeDollarGatewayCount;
        },
        loadedUsMonthIncome(state) {
            return state.usMonthIncome;
        },
        loadedMonthIncome(state) {
            return state.monthIncome;
        },

    },
    actions: {
        /**
         * Get the  Count customer
         * @param state
         * @param payload
         */
        [GET_CUSTOMER_COUNT](state, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(payload)
                    .then((response) => {
                        if (response.success) {
                            state.commit(SET_CUSTOMER_COUNT, response.result.clientsCount);
                            state.commit(SET_GATEWAY_COUNT, response.result.ActiveGatewayCount);
                            state.commit(SET_SATTLING_BALANCE, response.result.sattling);
                            state.commit(SET_MONTH_TRANSACTION_COUNT, response.result.MonthTransactionCount);
                            state.commit(SET_MONTH_DOLLER_TRANSACTION_COUNT, response.result.MonthDollarTransactionCount);
                            state.commit(SET_ACTIVE_DOLLER_GATEWAY_COUNT, response.result.activeDollarGatewayCount);
                            state.commit(SET_MONTH_INCOME, response.result.MonthIncome);
                            state.commit(SET_MONTH_Us_INCOME, response.result.UsMonthIncome);
                        }

                    })
                    .catch((error) => {
                    })
                    .finally(() => { });
            });
        },

    },
    mutations: {

        [SET_CUSTOMER_COUNT](state, payload) {
            state.customerCount = payload;
        },
        [SET_GATEWAY_COUNT](state, payload) {
            state.gatewayCount = payload;
        },
        [SET_SATTLING_BALANCE](state, payload) {
            state.sattlingBalance = payload;
        },
        [SET_MONTH_TRANSACTION_COUNT](state, payload) {
            state.monthTransactionCount = payload;
        },
        [SET_MONTH_DOLLER_TRANSACTION_COUNT](state, payload) {
            state.monthDollerTransactionCount = payload;
        },
        [SET_ACTIVE_DOLLER_GATEWAY_COUNT](state, payload) {
            state.activeDollarGatewayCount = payload;
        },
        [SET_MONTH_Us_INCOME](state, payload) {
            state.usMonthIncome = payload;
        },
        [SET_MONTH_INCOME](state, payload) {
            state.monthIncome = payload;
        },


    }
};